class StickyWidget extends HTMLElement {
  constructor() {
    super();
    this.trackedElement = null;
    this.updateStickyPosition = this.updateStickyPosition.bind(this);
  }

  connectedCallback() {
    const trackedSelector = this.getAttribute('data-track') || '.site-header';
    this.trackedElement = document.querySelector(trackedSelector);

    if (this.trackedElement) {
      this.observeTrackedElement();
      this.updateStickyPosition();
    }
  }

  observeTrackedElement() {
    const observer = new MutationObserver(this.updateStickyPosition);

    observer.observe(this.trackedElement, {
      attributes: true,
      attributeFilter: ['class'],
    });

    window.addEventListener('resize', this.updateStickyPosition);
  }

  updateStickyPosition() {
    if (this.trackedElement.classList.contains('site-header--stuck')) {
      const headerHeight = this.trackedElement.offsetHeight;
      this.style.top = `${headerHeight + 15}px`;
    } else {
      this.style.top = '0px';
    }
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.updateStickyPosition);
  }
}

customElements.define('sticky-widget', StickyWidget);
